import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  news: [],
  totalRows: 0,
  loading: false,
  error: null,
};

const newsSlice = createSlice({
  name: "News",
  initialState,
  reducers: {
    setLoading(state, action) {
      state.loading = action.payload;
    },
    setNews(state, action) {
      state.news = action.payload.data || [];
      state.totalRows =
        action.payload.totalData ||
        action.payload.totalItems ||
        action.payload.pagination?.totalNews ||
        action.payload.pagination?.totalItems ||
        0;
    },
    addNews(state, action) {
      state.news.unshift(action.payload);
    },
    updateNewsItem(state, action) {
      const index = state.news.findIndex((n) => n._id === action.payload._id);
      if (index !== -1) state.news[index] = action.payload;
    },
    deleteNewsItem(state, action) {
      state.news = state.news.filter((n) => n._id !== action.payload);
    },
    setError(state, action) {
      state.error = action.payload;
    },
  },
});

export const {
  setLoading,
  setNews,
  addNews,
  updateNewsItem,
  deleteNewsItem,
  setError,
} = newsSlice.actions;

export default newsSlice.reducer;
